import {LocalStorage} from '@guestapp/core';
import {Guest} from '@guestapp/sdk';
import {FEEDBACK_MODAL_SHOWN_KEY} from './constants';
import ChekinProSettings from '../../ChekinProSettings';

export const shouldShowFeedbackModalToUser = (data: Guest) => {
  const isShown = LocalStorage.get(FEEDBACK_MODAL_SHOWN_KEY);
  return !isShown && data.is_leader && !ChekinProSettings.isSDK;
};

export const setFeedbackModalShown = () => {
  LocalStorage.set(FEEDBACK_MODAL_SHOWN_KEY, true);
};
